declare namespace $ {

	type $mol_view__event_bog_ui_sheet_1 = $mol_type_enforce<
		({ 
			click( next?: ReturnType< $bog_ui_sheet['backdrop_click'] > ): ReturnType< $bog_ui_sheet['backdrop_click'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_list__rows_bog_ui_sheet_2 = $mol_type_enforce<
		ReturnType< $bog_ui_sheet['content'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_ui_sheet_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_ui_sheet extends $mol_view {
		backdrop_click( next?: any ): any
		Backdrop( ): $mol_view
		Content( ): $mol_list
		Panel( ): $mol_view
		showed( next?: boolean ): boolean
		side( ): string
		content( ): readonly(any)[]
		sub( ): readonly(any)[]
		attr( ): ({ 
			'bog_ui_sheet_showed': ReturnType< $bog_ui_sheet['showed'] >,
			'bog_ui_sheet_side': ReturnType< $bog_ui_sheet['side'] >,
		}) 
	}
	
}

//# sourceMappingURL=sheet.view.tree.d.ts.map